export const homeEN = {

    //Slika
    "learn_more": "About this service",

    //About
    "about": "About this service",
    "about_text": "FINA Validator is an e-service provided by the Financial agency that allows you to validate qualified and advanced electronic signatures/electronic seals supported by a qualified certificate made according to PAdES. XAdES and CAdES standards. All validation procedures are carried out in accordance with the eIDAS Regulation and ETSI standards using the EU Trusted Lists of Certification Service Providers.",
    "start_validating": "Start validating",

    //Dropzone
    "fina_validator": "Validator",
    "signed_document": "Signed document*",
    "upload_signed_text": "Load the electronically signed or sealed document („attached signature/seal“) or a separate signature/seal file when the original document is separated from its signature/seal („detached signature/seal“).",
    "original_document": "Original document ",
    "upload_original_text": "Load the original document file when it is separated from its signature/seal („detached signature/seal“).",
    "upload_original_text_extra": "[1] Load this document only in case of a separate signature/seal („detached signature/seal“).",
    "validate_button": "Validate document",
    "validating": "Validating...",

    //Validate
    "big_file": "Uploaded file is larger than allowed...",
    "validate_new": "Validate new document",
    "copy_info": "If you would like to use the retrieval capability of your validation reports, please save the specified paths. You can copy the path by pressing a button",

    //Perm links
    "cro": "Reports in Croatian",
    "eng": "Reports in English",
    "validation_reports": "Validation reports",
    "simple_report": "Simple report",
    "detailed_report": "Detailed report",
    "diagnostic_report": "Diagnostic report",
    "copy_simple": "Click to copy permanent link for simple report!",
    "download_simple": "Click to download simple PDF report!",
    "print_simple": "Click to print simple PDF report!",
    "copy_detailed": "Click to copy permanent link for detailed report!",
    "download_detailed": "Click to download detailed PDF report!",
    "print_detailed": "Click to print detailed PDF report!",
    "copy_diagnostic": "Click to copy permanent link for diagnostic report!",
    "download_diagnostic": "Click to download diagnostic PDF report!",
    "print_diagnostic": "Click to print diagnostic PDF report!",
    "no_signatures": "No e-signatures were found in the uploaded document...",

    //Instructions
    "user_guide": "User guide for FINA Validator web application.",
    "download_instructions": "Download user guide",

    //FAQ
    "faq": "Frequently asked questions",

    //Footer
    "info_contact": "User support: info@fina.hr / 0800 0080"
};